import { Link } from "react-router-dom";
import { Wind, Sparkles, ArrowRight } from "lucide-react";

const LOGO_URL = "https://customer-assets-jai6qajn.emergentagent.net/job_breathe-thrive/artifacts/muqcm9jc_Breathe%20To%20Thrive%20Logo.webp";

export default function Landing() {
  return (
    <div className="min-h-screen shell-bg">
      <header className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-full bg-navy flex items-center justify-center shadow-[0_4px_14px_rgba(44,45,91,0.25)]">
            <Wind size={20} className="text-gold" />
          </div>
          <div className="font-display font-bold text-navy text-lg leading-tight" data-testid="landing-brand-text">
            Breathe. Thrive. Live.
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/login" data-testid="landing-login-link" className="text-sm text-ink-mid hover:text-navy px-4 py-2">Sign in</Link>
          <Link to="/register" data-testid="landing-register-link" className="text-sm bg-navy text-warm-white px-5 py-2.5 rounded-full font-semibold hover:bg-navy-deep transition">Get started</Link>
        </div>
      </header>

      <section className="max-w-6xl mx-auto px-6 pt-16 pb-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-mauve-pale text-mauve text-xs font-semibold uppercase tracking-widest mb-6">
            <Sparkles size={12} /> Guided myofunctional therapy at home
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight" data-testid="landing-headline">
            <span className="text-navy block">Not just a course.</span>
            <span className="text-mauve block">The exhale you've been waiting for.</span>
          </h1>
          <p className="mt-6 text-lg text-ink-mid max-w-lg leading-relaxed">
            Replace scattered videos, PDFs, and forms with one integrated myofunctional therapy system. You will be guided from mouth breathing to nasal breathing — one session at a time.
          </p>
          <div className="mt-8 flex gap-3">
            <Link to="/register" data-testid="landing-cta" className="inline-flex items-center gap-2 bg-gold text-ink-dark px-6 py-3.5 rounded-full font-semibold hover:bg-gold-light hover:-translate-y-0.5 transition-all shadow-[0_4px_14px_rgba(201,169,110,0.3)]">
              Begin your family's journey <ArrowRight size={16} />
            </Link>
          </div>
        </div>

        {/* Hero logo — the real brand mark supplied by the owner. */}
        <div className="relative flex items-center justify-center" data-testid="hero-logo-wrap">
          <img
            src={LOGO_URL}
            alt="The Breathe to Thrive System"
            data-testid="hero-logo-img"
            loading="eager"
            className="w-full max-w-[520px] h-auto select-none"
            draggable="false"
          />
        </div>
      </section>
    </div>
  );
}
